// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Cc9eb","col":"styles_col__32Uyi","fulfillmentStatus":"styles_fulfillmentStatus__1Kk8r","emailCol":"styles_emailCol__nKz_g"};